import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_FMMODULE_API_URL),
    'documenten': {
        items: [],
        item: {}
    },
    'triggers': {
        items: [],
        item: {}
    },
    'invoicerecognition': {
        items: [],
        item: {}
    }, 
    'invoicerecognition/unvalidated': {
        items: [],
        item: {}
    }       
}

const getters = {
    //List getters
    documenten: state => state['documenten'].items,
    triggers: state => state['triggers'].items,
    invoicerecognitiondata: state => state['invoicerecognition/unvalidated'].items,

    //Single getters
    trigger: state => state['triggers'].item,
    invoicerecognitionitem: state => state['invoicerecognition/unvalidated'].item,
}

const actions = {
    ...baseActions,
    setPositiveValidation(context, invoicerecognitionitem){
        context.commit('SET_POSITIVE_VALIDATION', invoicerecognitionitem);
    },
    setNegativeValidation(context, invoicerecognitionitem){
        context.commit('SET_NEGATIVE_VALIDATION', invoicerecognitionitem);
    }    
}

const mutations = {
    ...baseMutations,
	SET_POSITIVE_VALIDATION(state, invoicerecognitionitem) {
        invoicerecognitionitem.isCorrect = true
		state['invoicerecognition/unvalidated'].items = state['invoicerecognition/unvalidated'].items.filter(item => item !== invoicerecognitionitem)
	},
	SET_NEGATIVE_VALIDATION(state, invoicerecognitionitem) {
        invoicerecognitionitem.isCorrect = false
		state['invoicerecognition/unvalidated'].items = state['invoicerecognition/unvalidated'].items.filter(item => item !== invoicerecognitionitem)
	}     
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}